<template>
  <div>
    <v-dialog persistent v-model="dialog" width="50%">
      <template v-slot:activator="{ on, attrs }">
        <span class="pa-0 ma-0" v-bind="attrs" v-on="on">
          <slot/>
        </span>
      </template>
      <v-form
        ref="form"
        v-model="form.valid"
        lazy-validation
        @submit.prevent="onSubmit"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            <span>Add client for container : {{ container }}</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="form.fields.storage"
              :rules="form.rules.storage"
              disabled
              label="Storage"
              required
            ></v-text-field>
            <v-text-field
              v-model="form.fields.container"
              :rules="form.rules.container"
              disabled
              label="Container"
              required
            ></v-text-field>
            <v-text-field
              v-model="form.fields.clientName"
              label="Client Name"
              :rules="form.rules.clientName"
              required
            ></v-text-field>
            <v-text-field
              v-model="form.fields.clientId"
              label="Client Id"
              :rules="form.rules.clientId"
              :disabled="edit"
              required
            ></v-text-field>
            <h3>Permissions</h3>
            <v-container fluid>
              <v-row justify="center">
                <v-col
                  class="ma-0 pa-0"
                  v-for="permission of permissionsRef"
                  :key="permission.key"
                  md="3"
                >
                  <v-checkbox
                    v-model="form.fields.permissions"
                    :label="permission.label"
                    hide-details
                    :value="permission.key"
                    :rules="form.rules.permissions"
                    required
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit" color="primary" :disabled="!form.valid">
              Submit
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="dialog = false">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import {createNamespacedHelpers} from 'vuex'
import {atLeastChoices, minLengthRule, requiredRule} from '@/utils/rules.js'

const {mapActions} = createNamespacedHelpers('storage')
export default {
  name: 'ClientForm',
  data() {
    return {
      form: {
        valid: false,
        fields: {
          clientName: this.clientName,
          clientId: this.clientId,
          storage: this.storage,
          container: this.container,
          permissions: this.permissions
        },
        rules: {
          storage: [requiredRule()],
          container: [requiredRule()],
          clientName: [requiredRule(), minLengthRule(3)],
          clientId: [requiredRule(), minLengthRule(5)],
          permissions: [atLeastChoices(1)]
        }
      },
      dialog: false,
      permissionsRef: [
        {label: 'Add', key: 'A'},
        {label: 'Create', key: 'C'},
        {label: 'Delete', key: 'D'},
        {label: 'DeleteVersion', key: 'DV'},
        {label: 'Execute', key: 'E'},
        {label: 'List', key: 'L'},
        {label: 'Move', key: 'M'},
        {label: 'Read', key: 'R'},
        {label: 'Tag', key: 'T'},
        {label: 'Write', key: 'W'}
      ]
    }
  },
  methods: {
    ...mapActions(['addClient']),
    async onSubmit() {
      await this.addClient({
        ...this.form.fields,
        permissions: this.form.fields.permissions.join(',')
      })
      this.dialog = false
    }
  },
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    storage: {
      type: String,
      required: true
    },
    container: {
      type: String,
      required: true
    },
    clientName: {
      type: String,
      required: false,
      default: ''
    },
    clientId: {
      type: String,
      required: false,
      default: ''
    },
    permissions: {
      type: Array,
      required: false,
      default: () => []
    }
  }
}
</script>
